import * as React from 'react';
import {
    getIconActionDescription,
    getIconTooltipAndDescription,
    IStringResources,
} from 'modern-font-picker-core';
import { IStyleFunctionOrObject, memoizeFunction } from '@fluentui/react';
import { PinActionButton } from './PinActionButton';
import {
    IPinActionButtonProps,
    IPinActionButtonStyleProps,
    IPinActionButtonStyles,
} from './PinActionButton.types';
import { GroupedComboBoxRenderIcon, OnRenderIconResult } from 'grouped-combobox-web';

const cachedRenderIconCallback = memoizeFunction(
    (
            isSubscriber: boolean,
            stringResources: IStringResources,
            allowFontInfoPaneCommands: boolean,
            allowPinning: boolean,
            styles?: IStyleFunctionOrObject<IPinActionButtonStyleProps, IPinActionButtonStyles>
        ) =>
        (props: IPinActionButtonProps): OnRenderIconResult => {
            const { item, isActive } = props;

            const iconTooltipAndDescription = getIconTooltipAndDescription(
                item,
                stringResources,
                isSubscriber
            );

            if (!iconTooltipAndDescription) {
                return [null];
            }
            const [tooltip, description] = iconTooltipAndDescription;

            const pinActionButton = React.createElement(PinActionButton, {
                ...props,
                styles,
                tooltipText: tooltip,
                allowFontInfoPaneCommands,
            });

            const actionDescription = isActive
                ? getIconActionDescription(
                      item,
                      isSubscriber,
                      allowFontInfoPaneCommands,
                      allowPinning,
                      stringResources
                  )
                : undefined;

            return [pinActionButton, description, actionDescription];
        }
);

export function createRenderIconCallback(
    isSubscriber: boolean,
    stringResources: IStringResources,
    allowFontInfoPaneCommands: boolean,
    allowPinning: boolean,
    styles?: IStyleFunctionOrObject<IPinActionButtonStyleProps, IPinActionButtonStyles>
): GroupedComboBoxRenderIcon {
    return cachedRenderIconCallback(
        isSubscriber,
        stringResources,
        allowFontInfoPaneCommands,
        allowPinning,
        styles
    );
}
